import React from 'react';
import { Component } from '@poa/core';
import { Observer, observable, action } from '@poa/state';
import 'react-tippy/dist/tippy.css';
import RouteLoading from '../../route-loading';
import { getMenuIcon } from '../../icons/menu';
import LinksModal from '../../links-modal/links-modal';

class ShareLinksPage extends React.Component {
  store; // injected by Poa
  actions; // injected by Poa
  env; // injected by Poa


  localState = observable({
    isCredModalOpened: false,
    selectedCredId: null,
    credentials: { data: [], meta: { hasError: false, loaded: false } }
  });

  onCredModalOpen = action(credId => {
    this.localState.selectedCredId = credId;
    this.localState.isCredModalOpened = true;
  });

  onCredModalClose = action(() => {
    this.localState.isCredModalOpened = false;
    this.localState.selectedCredId = null;
    this.fetchItems();
  });


  componentDidMount() {
    this.fetchItems();
  }

  fetchItems() {
    this.env.http
      .get('credentials')
      .then(
        action(({ data }) => {
          this.localState.credentials.data.replace(data);
          this.localState.credentials.meta.hasError = false;
          this.localState.credentials.meta.loaded = true;
        })
      )
      .catch(
        action(() => {
          this.localState.credentials.meta.hasError = true;
          this.localState.credentials.meta.loaded = false;
        })
      );
  }

  render() {

    const body = this.localState.credentials.data.map(cred => {
      let watchButton = (
        <>
          <button className='popup__btn edit-proxy' onClick={() => this.onCredModalOpen(cred.id)}>
            {getMenuIcon('proxy')}
          </button>
        </>
      );

      let statusColor = 'transparent';
      if (cred.status && cred.status !== 'active') {
        statusColor = cred.status === 'inactive'? 'red': 'yellow';
      }

      return (
        <tr key={cred.id}  style={{backgroundColor: statusColor}}>
          <td style={{ width: '150px' }}>{cred.login}</td>
          <td style={{ width: '80px' }}>{cred.title}</td>
          <td style={{ width: '30px' }}>{watchButton}</td>
        </tr>
      );
    });

    return (
      <RouteLoading meta={this.localState.credentials.meta} withoutNavbar={true}>
        <div className='content'>
          <div className='container'>
            <div className='inner'>
              <div className='inner-scroll credentials-table'>
                <Observer>
                  {() => (
                    <table className='table' style={{ tableLayout: 'fixed' }}>
                      <thead>
                        <tr>
                            <th style={{ width: '150px' }}>Account</th>
                            <th style={{ width: '80px' }}>Title</th>
                            <th style={{ width: '30px' }}>Watch</th>
                        </tr>
                      </thead>
                      <tbody>{body}</tbody>
                    </table>
                  )}
                </Observer>

              </div>
            </div>
          </div>
          <Observer>
            {() => (
              <LinksModal
                isOpen={this.localState.isCredModalOpened}
                onRequestClose={this.onCredModalClose}
                selectedCredId={this.localState.selectedCredId}
              />
            )}
          </Observer>
        </div>
      </RouteLoading>
    );
  }
}

export default Component()(ShareLinksPage);